import {useSelectedCompany} from "@/hooks/useUserHooks";
import useUserStore from "@/store/user";
import {useMemo} from "react";

const usePlanFlow = () => {
  const selectedCompany = useSelectedCompany();
  const hasLoadedUser = useUserStore(state => !!state.user.id);
  const hasPlan = useUserStore(state => !!state.user.package_subscription);
  const hasAnyTypeOfCampaign = useMemo(() => selectedCompany?.has_campaign, [selectedCompany?.has_campaign]);

  const flowType = useMemo(() => {
    if (!hasLoadedUser) return "LOADING";
    if (hasPlan && hasAnyTypeOfCampaign) return "HAS_PLAN_HAS_CAMPAIGN";
    if (hasPlan && !hasAnyTypeOfCampaign) return "HAS_PLAN_NO_CAMPAIGN";
    if (hasAnyTypeOfCampaign) return "NO_PLAN_HAS_CAMPAIGN";
    else return "NO_PLAN_NO_CAMPAIGN";
  }, [hasLoadedUser, hasPlan, hasAnyTypeOfCampaign]);

  return flowType;
};

export default usePlanFlow;
